import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Spinner} from 'kpc';

var _$tmp0 = {
    'size': 'large'
};
var _$tmp1 = {
    'size': 'small'
};
var _$tmp2 = {
    'size': 'mini'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Spinner, _$tmp0),
        _$cc(Spinner),
        _$cc(Spinner, _$tmp1),
        _$cc(Spinner, _$tmp2)
    ], 4 /* HasNonKeyedChildren */);
};